import { Injectable } from "@angular/core";

import { Extension, Prec } from "@codemirror/state";
import { KeyBinding, keymap } from "@codemirror/view";


@Injectable()
export class CodeEditorKeyboardService {

    public getKeyboardExtension(bindings: KeyBinding[]): Extension {
        if (!bindings?.length) return null;

        // Create a keyboard extension with high precedence,
        // to be able to override default hotkeys.
        return Prec.high(keymap.of(bindings));
    }
}